import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from './../store'
import HomeView from '../views/HomeView.vue'
import LoginView from '../auth/LoginView.vue'
import IndexUser from '../views/users/IndexUser.vue'
import IndexProjet from '../views/projets/IndexProjet.vue'
import IndexMessage from '../views/messages/IndexMessage.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/se-connecter',
    name: 'login',
    component: LoginView
  },
  {
    path: '/utilisateurs',
    name: 'users',
    component: IndexUser
  },
  {
    path: '/projets',
    name: 'projects',
    component: IndexProjet
  },
  {
    path: '/messages',
    name: 'messages',
    component: IndexMessage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && !store.getters.authenticated) next({ name: 'login' })
  else next()
})

export default router
